import { BaseEvent } from '~/app/tracking/events/base-event';
import { EventAction, RelatedProducts } from '~/app/tracking/feld-m-types';
import { ConfiguredCarConflict } from '~/graphql/__generated__/graphql';

export type AcceptConflictParams = {
	currentView?: string;
	label: string;
	value: string;
	data?: ConfiguredCarConflict;
	relatedProducts?: RelatedProducts;
};

export class AcceptConflict extends BaseEvent {
	constructor({ label, value, relatedProducts }: AcceptConflictParams) {
		super({
			eventInfo: {
				eventAction: EventAction.InternalLink,
				eventName: 'configuration assistant - click to apply configuration change',
			},
			attributes: {
				componentName: 'configuration-assistant',
				label,
				elementName: 'button',
				value: value.split(' ').join(''),
				relatedProducts,
			},
		});
	}
}
